
import { instance } from '@/utils/http.js'

// 获取一级能力数据
export const getCapability = function (params) {
  return instance({
    url: '/api/v1/public/get_capability1',
    method: 'get',
    params
  })
}

// 能力训练
export const capabilityTrain = function (data) {
  return instance({
    url: '/api/v1/xmode/capability_train',
    method: 'post',
    data
  })
}


// 错题
export const wrongPaper = function (data) {
  return instance({
    url: '/api/v1/my/wrong_paper',
    method: 'post',
    data
  })
}

export const freeQuestion = function (data) {
  return instance({
    url: "/api/v1/free/free_question",
    method: 'post',
    data
  })
}
